import { createContext } from 'react'
import { ModelAnomalyWithModelName } from 'src/types'

export type ModelAnomalyContextValue = {
  anomalies: ModelAnomalyWithModelName[]
  isLoading: boolean
}

// Note: this only appears to be used in `useAnomalyAreas`
// The default value is only returned if the context is accessed outside of the provider
// That should really throw an exception, since this is a code error
export const ModelAnomaliesContext = createContext<
  ModelAnomalyContextValue | undefined
>(undefined)
